/* eslint-disable */ 
import Vue from 'vue';
import Router from 'vue-router';
// import Home from './views/Home.vue';

Vue.use(Router);

const APP_NAME = process.env.VUE_APP_NAME;

// lazy load function
function loadView(view) {
	return () => import(/* webpackChunkName: "view-[request]" */ `@/views/${view}.vue`);
}
// lazy load function
function loadComponent(view) {
	return () => import(/* webpackChunkName: "component-[request]" */ `@/components/${view}.vue`);
}

export default new Router({
	mode: 'history',
	base: process.env.BASE_URL,
	// linkActiveClass: 'active',
	scrollBehavior() {
		return { x: 0, y: 0 };
	},
	routes: [
		// Dashboard
		{
			path: '/',
			name: 'dashboard',
			component: loadView('Rundowns'),
			meta: {
				title: `Dashboard - ${APP_NAME}`,
				gtm: 'Dashboard',
			},
		},
		// Login
		{
			path: '/login',
			name: 'login',
			component: loadView('Login'),
			meta: {
				title: `Login - ${APP_NAME}`,
				gtm: 'Login',
			},
		},
		// Register
		{
			path: '/register',
			name: 'register',
			component: loadView('Register'),
			meta: {
				title: `Register - ${APP_NAME}`,
				gtm: 'Register',
			},
		},
		// Magic Link
		{
			path: '/magic-link',
			name: 'magicLink',
			component: loadView('MagicLink'),
			meta: {
				title: `Magic Link - ${APP_NAME}`,
				gtm: 'Magic Link',
			},
		},
		// Auto Login
		{
			path: '/auto_login',
			name: 'AutoLogin',
			component: loadView('AutoLogin'),
			meta: {
				title: `Auto Login - ${APP_NAME}`,
				gtm: 'Auto Login',
			},
		},
		// Reset Password
		{
			path: '/password/reset',
			name: 'ResetPassword',
			component: loadView('ChangePassword'),
			meta: {
				title: `Reset Password - ${APP_NAME}`,
				gtm: 'Reset Password',
			},
		},
		// Change Password
		{
			path: '/change-password',
			name: 'ChangePassword',
			component: loadView('ChangePassword'),
			meta: {
				title: `Change Password - ${APP_NAME}`,
				gtm: 'Change Password',
			},
		},
		// Logout
		{
			path: '/logout',
			name: 'logout',
			component: loadView('Logout'),
			meta: {
				title: `Logout - ${APP_NAME}`,
				gtm: 'Logout',
			},
		},
		// Verify
		{
			path: '/user/verify',
			name: 'Verify',
			component: loadView('Verify'),
			meta: {
				title: `Verify - ${APP_NAME}`,
				gtm: 'Verify',
			},
		},
		// checkout
		{
			path: '/checkout',
			name: 'checkout',
			component: loadView('Checkout'),
			meta: {
				title: `checkout - ${APP_NAME}`,
				gtm: 'Checkout',
			},
		},
		// Users
		{
			path: '/users',
			name: 'Users',
			component: loadView('Users'),
			meta: {
				title: `Users - ${APP_NAME}`,
				gtm: 'Users',
			},
		},
		// Users Log
		{
			path: '/users-log',
			name: 'UsersLog',
			component: loadView('UsersLog'),
			meta: {
				title: `Users Log - ${APP_NAME}`,
				gtm: 'Users Log',
			},
		},
		// Announcements
		{
			path: '/announcements',
			name: 'Announcements',
			component: loadView('Announcements'),
			meta: {
				title: `Announcements - ${APP_NAME}`,
				gtm: 'Announcements',
			},
		},
		// lottie
		{
			path: '/lottie',
			name: 'Lottie',
			component: loadComponent('LottiePlayer'),
			meta: {
				title: `Lottie - ${APP_NAME}`,
				gtm: 'Lottie Player',
			},
		},
		// Manage Composition
		{
			path: '/compositions/',
			name: 'Composition',
			component: loadView('Composition'),
			meta: {
				title: `Composition - ${APP_NAME}`,
				gtm: 'Manage Composition',
			},
		},
		// Manage Composition show all
		{
			path: '/compositions/show/:status',
			name: 'CompositionAll',
			component: loadView('Composition'),
			meta: {
				title: `Composition - ${APP_NAME}`,
				gtm: 'Manage Composition',
			},
		},
		// Composition Editor new
		{
			path: '/compositions/editor',
			name: 'CompositionEditorNew',
			component: loadComponent('CompositionEditor'),
			meta: {
				title: `Composition Editor - ${APP_NAME}`,
				gtm: 'Composition Editor',
				hideSidebar: true,
			},
		},
		// Composition Editor update
		{
			path: '/compositions/editor/:id',
			name: 'CompositionEditorUpdate',
			component: loadComponent('CompositionEditor'),
			meta: {
				title: `Composition Editor - ${APP_NAME}`,
				gtm: 'Composition Editor',
				hideSidebar: true,
			},
		},
		// Composition Editor view
		{
			path: '/compositions/view/:id',
			name: 'CompositionEditorView',
			component: loadComponent('CompositionEditor'),
			meta: {
				title: `Composition - ${APP_NAME}`,
				gtm: 'Composition ',
				hideSidebar: true,
			},
		},
		// Collaborators
		{
			path: '/collaborators',
			name: 'Collaborators',
			component: loadView('Collaborators'),
			meta: {
				title: `Collaborators - ${APP_NAME}`,
				gtm: 'Collaborators',
			},
		},
		// Invitation Collaborators
		{
			path: '/invitation/collaborator/:code',
			name: 'InvitationCollaborators',
			component: loadView('CollaboratorsInvitation'),
			meta: {
				title: `Invitation Collaborators - ${APP_NAME}`,
				gtm: 'Invitation Collaborators',
			},
		},
		// Displays
		{
			path: '/displays',
			name: 'Displays',
			component: loadView('Displays'),
			meta: {
				title: `Displays - ${APP_NAME}`,
				gtm: 'Displays',
			},
		},
		// Displays Multiview
		{
			path: '/multiview-displays/:id',
			name: 'MultiviewOutputDisplay',
			component: loadView('MultiviewOutputDisplay'),
			meta: {
				title: `Multiview Output - ${APP_NAME}`,
				gtm: 'Multiview Output',
			},
		},
		// Displays live
		{
			path: '/displays/live/:displaySlug/:id',
			name: 'DisplayLive',
			component: loadView('DisplayLive'),
			meta: {
				title: `Display live - ${APP_NAME}`,
				gtm: 'Displays',
			},
		},
		// lightstream live
		{
			path: '/lightstream/live/:displaySlug/:id',
			name: 'LightStream',
			component: loadView('LightStream'),
			meta: {
				title: `LightStream live - ${APP_NAME}`,
				gtm: 'LightStream',
			},
		},
		// Display Sizes
		{
			path: '/display-sizes',
			name: 'DisplaySizes',
			component: loadView('DisplaySizes'),
			meta: {
				title: `Display Sizes - ${APP_NAME}`,
				gtm: 'Display Sizes',
			},
		},
		// Settings
		{
			path: '/settings',
			name: 'Settings',
			component: loadView('Settings'),
			meta: {
				title: `Settings - ${APP_NAME}`,
				gtm: 'Settings',
			},
		},
		// Rundowns
		{
			path: '/rundowns',
			name: 'Rundowns',
			component: loadView('Rundowns'),
			meta: {
				title: `Rundown - ${APP_NAME}`,
				gtm: 'Rundown',
			},
		},
		// Rundowns - Recent
		{
			path: '/rundowns/recent',
			name: 'RundownsRecent',
			component: loadView('Rundowns'),
			props: {
				mode: 'recent',
			},
			meta: {
				title: `Rundown - ${APP_NAME}`,
				gtm: 'Rundown',
			},
		},

		// Rundowns - Pinned
		{
			path: '/rundowns/pinned',
			name: 'RundownsPinned',
			component: loadView('Rundowns'),
			props: {
				mode: 'pinned',
			},
			meta: {
				title: `Rundown - ${APP_NAME}`,
				gtm: 'Rundown',
			},
		},
		// Rundown - create new
		{
			path: '/rundowns/editor/',
			name: 'RundownCreate',
			component: loadView('RundownEditor'),
			props: route => ({
				slug: route.params.slug,
			}),
			meta: {
				title: `Rundown - ${APP_NAME}`,
				gtm: 'Rundown',
				hideSidebar: true,
			},
		},
		// Rundown - update rundown
		{
			path: '/rundowns/editor/:slug/',
			name: 'RundownEditor',
			component: loadView('RundownEditor'),
			props: route => ({
				slug: route.params.slug,
			}),
			meta: {
				title: `Rundown - ${APP_NAME}`,
				gtm: 'Rundown',
				hideSidebar: true,
			},
		},
		// Rundown - update rundown
		{
			path: '/rundowns/command/editor/:slug/',
			name: 'RundownCommandEditor',
			component: loadView('RundownCommandEditor'),
			props: route => ({
				slug: route.params.slug,
			}),
			meta: {
				title: `Rundown Command - ${APP_NAME}`,
				gtm: 'Rundown Command',
				hideSidebar: true,
			},
		},
		// Manage Feedbacks
		{
			path: '/feedbacks',
			name: 'ManageFeedbacks',
			component: loadView('ManageFeedbacks'),
			meta: {
				title: `Manage Feedbacks - ${APP_NAME}`,
				gtm: 'Manage Feedbacks',
			},
		},
		// Editor Templates
		{
			path: '/templates/:template',
			name: 'TemplateEditor',
			component: loadComponent('TemplateEditor'),
			meta: {
				title: `Template Editor - ${APP_NAME}`,
				gtm: 'Template Editor',
				hideSidebar: true,
			},
		},
		// Editor Lottie non admin
		{
			path: '/lotties/:template',
			name: 'UploadLottie',
			component: loadComponent('UploadLottieNonAdmin'),
			meta: {
				title: `Upload Lottie - ${APP_NAME}`,
				gtm: 'Upload Lottie',
				hideSidebar: true,
			},
		},
		// Live
		{
			path: '/live/:slug',
			name: 'Live',
			component: loadView('StreamDisplayLive'),
			props: {
				type: 'live',
			},
			meta: {
				title: `Live - ${APP_NAME}`,
				gtm: 'Live',
			},
		},
		// Live
		{
			path: '/preview/:slug',
			name: 'Preview',
			component: loadView('StreamDisplayPreview'),
			props: {
				type: 'preview',
			},
			meta: {
				title: `Preview - ${APP_NAME}`,
				gtm: 'Preview',
			},
		},
		// play rundown item (solo)
		{
			path: '/item/play/:id',
			name: 'StreamDisplayItemRundown',
			component: loadView('StreamDisplayItemRundown'),
			props: {
				type: 'play',
			},
			meta: {
				title: `Play - ${APP_NAME}`,
				gtm: 'Play',
			},
		},
		// Category
		{
			path: '/categories',
			name: 'Categories',
			component: loadView('Categories'),
			meta: {
				title: `Category Editor - ${APP_NAME}`,
				gtm: 'Category Editor',
			},
		},
		// Packages
		{
			path: '/packages',
			name: 'Packages',
			component: loadView('Packages'),
			meta: {
				title: `Packages - ${APP_NAME}`,
				gtm: 'Packages',
			},
		},
		// Promos
		{
			path: '/promos',
			name: 'Promos',
			component: loadView('Promos'),
			meta: {
				title: `Promos - ${APP_NAME}`,
				gtm: 'Promos',
			},
		},
		// Promo
		{
			path: '/promo/:uid',
			name: 'PromoUID',
			component: loadView('HiddenPackage'),
			meta: {
				title: `Grafias Promo - ${APP_NAME}`,
				gtm: 'Grafias Promo',
			},
		},
		// biliing
		{
			path: '/billings',
			name: 'Billings',
			component: loadView('Billings'),
			meta: {
				title: `Billings - ${APP_NAME}`,
				gtm: 'Billings',
			},
		},
		// Statistics
		{
			path: '/statistics',
			name: 'Statistics',
			component: loadView('Statistics'),
			meta: {
				title: `Statistics - ${APP_NAME}`,
				gtm: 'Statistics',
			},
		},
		// Statistics
		{
			path: '/my-statistics',
			name: 'MyStatistics',
			component: loadView('MyStatistics'),
			meta: {
				title: `My Statistics - ${APP_NAME}`,
				gtm: 'My Statistics',
			},
		},
		// 404
		{
			path: '/error-404',
			name: 'Error404',
			component: loadComponent('Error404'),
			meta: {
				title: '404',
				gtm: 'Error 404',
				hideSidebar: true,
			},
		},
		{
			path: '/confirmation-email',
			name: 'ConfirmationEmail',
			component: loadView('ConfirmationEmail'),
			meta: {
				title: 'Confirmation Email',
				gtm: 'Confirmation Email',
			},
		},
		{
			path: '/medias/:rundownId/:uid',
			name: 'SharedMisc',
			component: loadView('SharedMisc'),
			meta: {
				title: 'Shared Misc',
				gtm: 'Shared Misc',
			},
		},
		// Promos
		{
			path: '/calendar',
			name: 'CalendarView',
			component: loadView('CalendarView'),
			meta: {
				title: `Calendar View - ${APP_NAME}`,
				gtm: 'Calendar View',
			},
		},
    // get invoice
		{
			path: '/invoice/download/:id',
			name: 'InvoiceDownload',
			component: loadView('InvoiceDownload'),
			meta: {
				title: `Invoice Download - ${APP_NAME}`,
				gtm: 'Invoice Download',
			},
		},
		
		// Redirect to 404 page, if no match found
		{
			path: '/:pathMatch(.*)*',
			redirect: '/error-404',
		},
	],
});
